import { useQuery } from '@tanstack/react-query'
import { contentVersionAnnotations } from '../../v3/contentVersionAnnotations'
import { globalQueryKeys } from '../queryKeys'
import { flattenContentVersionAnnotations } from './selectors'

/**
 * Reads the pin annotations for a version, flattened oldest-first.
 *
 * No `staleTime`/`gcTime`: annotations are actively created here, so the list must
 * always refetch on mount and invalidate.
 */
export const useContentVersionAnnotations = (
  versionUuid: string,
  enabled = true
) =>
  useQuery({
    queryKey: globalQueryKeys.contentVersionAnnotations(versionUuid),
    queryFn: () => contentVersionAnnotations.readCollection({ versionUuid }),
    enabled,
    select: flattenContentVersionAnnotations,
  })
